import * as React from "react";
const SvgFiRrSourceData = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-source-data_svg__a)">
      <path
        fill="#062147"
        d="M23 22a2 2 0 0 1-2 2H3a2 2 0 1 1 0-4v-7c0-2.206 1.794-4 4-4h1a1 1 0 1 1 0 2H7c-1.103 0-2 .897-2 2v7h3.5l1 1h5l1-1H19v-7c0-1.103-.897-2-2-2h-1a1 1 0 1 1 0-2h1c2.206 0 4 1.794 4 4v7a2 2 0 0 1 2 2M7.793 13.414a1 1 0 0 0 0 1.414l2.44 2.44a2.48 2.48 0 0 0 1.767.731c.668 0 1.296-.26 1.768-.732l2.44-2.439a.999.999 0 1 0-1.415-1.414L13 15.207V8a1 1 0 1 0-2 0v7.207l-1.793-1.793a1 1 0 0 0-1.414 0M16 7a1 1 0 0 0 1-1V5a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1m-4-3a1 1 0 0 0 1-1V2a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1m6-1a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1M6 3a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1m1 3a1 1 0 1 0 2 0V5a1 1 0 1 0-2 0zM23.385.077a.997.997 0 0 0-1.308.538l-2.5 6a1 1 0 0 0 1.845.77l2.5-6a1 1 0 0 0-.537-1.308M3.5 8a1 1 0 0 0 .922-1.385l-2.499-6a1 1 0 0 0-1.846.77l2.5 6A1 1 0 0 0 3.5 8"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-source-data_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSourceData;
